import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Hook to determine if the current screen size is mobile (small devices).
 * Matches screen widths 'sm' and below (usually up to 600px).
 * @returns True if screen width is small/mobile.
 */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};

/**
 * Hook to determine if the current screen size is tablet.
 * Matches screen widths between 'md' (inclusive) and 'lg' (exclusive), typically 900px to 1200px.
 * @returns True if screen width is tablet size.
 */
export const useIsTablet = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between('md', 'lg'));
};

/**
 * Hook to determine if the current screen size is tablet or larger.
 * Matches screen widths 'md' and above (usually 900px and wider).
 * @returns True if screen width is tablet or larger.
 */
export const useIsTabletUp = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
};

export const useIsTabletDown = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

/**
 * Hook to determine if the current screen size is desktop.
 * Matches screen widths 'lg' and above (usually 1200px and wider).
 * @returns True if screen width is desktop size.
 */
export const useIsDesktop = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('lg'));
};

export const useIsDesktopDown = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('lg'));
};

export const useIsDesktopLarge = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('xl'));
};
